<template>
    <dash
        icon="fa fa-file-text-o"
        titulo="CERTIDÕES"
        @click.native="$router.push(rota)"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        rota: {
            type: Object,
            default: () => ({
                name: 'FornecedorCertidoes'
            })
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
